import { use } from 'react';

import { ViewportContextObj } from '../context';
import { type ViewportContext } from '../types';

interface UseViewportOptions {
  readonly strict?: boolean;
}

export type UseViewportContextReturn<O extends UseViewportOptions> = O extends {
  readonly strict: false;
}
  ? undefined | ViewportContext
  : ViewportContext;

export const useViewport = <O extends UseViewportOptions>(
  options?: O,
): UseViewportContextReturn<O> => {
  const context = use(ViewportContextObj);
  if (!context) {
    if (options?.strict === false) {
      return undefined as UseViewportContextReturn<O>;
    }
    throw new Error("The 'useViewport' hook can only be used inside of the 'ViewportProvider'!");
  }
  return context;
};
